import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWarningSign: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWarningSign"><Path d="M2.5 20.5L6.5 3.5H17.5M17.5 3.5L21.5 20.5M17.5 3.5H11.5M13.5 20.5L14.2059 17.5M14.2059 17.5H3.5M14.2059 17.5H20.5M14.2059 17.5L17.2647 4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWarningSign;
